import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, StatusBadge } from "@/components/shared";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress as ProgressBar } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Dog, Target, ArrowRight, GraduationCap } from "lucide-react";

export default function Progress() {
  const navigate = useNavigate();
  const [dogs, setDogs] = useState([]);
  const [homework, setHomework] = useState([]);

  useEffect(() => {
    api.get("/dogs").then((r) => setDogs(r.data)).catch(() => {});
    api.get("/homework").then((r) => setHomework(r.data)).catch(() => {});
  }, []);

  const hwFor = (dogId) => homework.filter((h) => h.dog_id === dogId);
  const pct = (hw) => hw.length ? Math.round((hw.filter((h) => ["completed", "reviewed"].includes(h.status)).length / hw.length) * 100) : 0;

  return (
    <div>
      <PageHeader title="Progress" subtitle="Track your dog's training level and homework completion." />
      <div className="grid md:grid-cols-2 gap-5">
        {dogs.map((d) => {
          const hw = hwFor(d.id);
          const p = pct(hw);
          return (
            <Card key={d.id} className="border-border hover:shadow-sm transition-all" data-testid="progress-card">
              <CardHeader>
                <CardTitle className="font-heading text-lg flex items-center justify-between">
                  <span className="flex items-center gap-2"><Dog size={18} strokeWidth={1.5} /> {d.name}</span>
                  <StatusBadge value={d.current_level} />
                </CardTitle>
                <div className="text-sm text-muted-foreground">{d.breed}</div>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex items-center gap-2">
                  <span className="text-xs uppercase tracking-wide font-semibold text-muted-foreground">Progress status</span>
                  <StatusBadge value={d.progress_status} />
                </div>
                <div>
                  <div className="flex items-center justify-between text-sm mb-1.5">
                    <span className="text-muted-foreground">Homework completion</span>
                    <span className="font-medium">{p}%</span>
                  </div>
                  <ProgressBar value={p} className="h-2" />
                  <div className="text-xs text-muted-foreground mt-1">{hw.filter((h) => ["completed", "reviewed"].includes(h.status)).length} of {hw.length} done</div>
                </div>
                {d.current_program && (
                  <div className="flex items-center gap-1.5 text-sm text-muted-foreground"><GraduationCap size={14} /> {d.current_program}</div>
                )}
                <div>
                  <div className="text-xs uppercase tracking-wide font-semibold text-muted-foreground mb-1 flex items-center gap-1.5"><Target size={13} /> Training goals</div>
                  <p className="text-sm">{d.training_goals || "—"}</p>
                </div>
                <Button variant="outline" size="sm" className="w-full gap-1.5" onClick={() => navigate(`/dogs/${d.id}`)} data-testid="progress-view-journey">View full journey <ArrowRight size={14} /></Button>
              </CardContent>
            </Card>
          );
        })}
        {dogs.length === 0 && <p className="text-muted-foreground col-span-full text-center py-12">No dogs yet.</p>}
      </div>
    </div>
  );
}
